export const UI_STATUS = {
    INITIALIZING: "INITIALIZING",
    IDLE: "IDLE",
    ORDER_PROCESSING: "ORDER_PROCESSING",
    BLOCKED: "BLOCKED",
} as const;

export type UIStatus = (typeof UI_STATUS)[keyof typeof UI_STATUS];
